export enum GENERAL_CHOICE {
  VORVERSICHERUNG = 'vorversicherung',
  SELBSTBETEILIGUNG = 'selbstbeteiligung',
  PAYMENT_METHOD = 'zahlart',
  PAYMENT_PERIOD = 'zahlweise',
  DECKUNGSSUMME = 'deckungssumme',
  LAUFZEIT = 'laufzeit',
  VORSCHADEN = 'vorschaden',
  YEARS = 'jahre',
  GENDER = 'geschlecht',
  PREVIOUS_INSURANCE_CANCELED_BY = 'vorversicherungKuendigender',
  TARIFART = 'tarifart',
}

export enum GENERAL_META {
  VORSCHADEN_EXISTS = 'exists',
  VORSCHADEN_ONE_DAMAGE = 'oneDamage',
  VORSCHADEN_TWO_DAMAGES = 'twoDamages',
  VORSCHADEN_MORE_THAN_TWO_DAMAGES = 'moreThanTwoDamages',
  VORSCHADEN_MORE_THAN_THREE_DAMAGES = 'moreThanThreeDamages',

  VORVERSICHERUNG_INVALID = 'invalid',

  PAYMENT_METHOD_NEEDS_BANK_DETAILS = 'needsBankDetails',

  TARIFART_HAS_CHILDREN = 'hasChildren',
  TARIFART_HAS_PARTNER = 'hasPartner',
}
